module.exports = __webpack_public_path__ + "static/img/mall_banner.03f5481.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/mall_banner.png
// module id = t1FS
// module chunks = 0